export const globalMixin = {
  methods: {
    // Converts a local date to UTC
    convertToUTC(localDateTime) {
      if (!localDateTime) return null;

      // Expected format: 'YYYY-MM-DDTHH:mm'
      const dateTimeParts = localDateTime.split("T");
      if (dateTimeParts.length !== 2) return null;

      const dateParts = dateTimeParts[0].split("-");
      const timeParts = dateTimeParts[1].split(":");

      if (dateParts.length !== 3 || timeParts.length < 2) return null;

      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Months are zero-indexed
      const day = parseInt(dateParts[2], 10);
      const hours = parseInt(timeParts[0], 10);
      const minutes = parseInt(timeParts[1], 10);

      const date = new Date(year, month, day, hours, minutes);
      return date.toISOString();
    },

    // Converts a UTC date to the user's local time
    convertToLocalTime(utcDate) {
      if (!utcDate) return null;

      const date = new Date(utcDate);
      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }
      return date.toLocaleString();
    },
  },
};
